export default __webpack_public_path__ + "static/media/send_black_24dp.5b219cbc.svg";